/**
 * Vehicle finder backed by the complete generated catalog asset.
 * Trim / Engine is intentionally not exposed here because it belongs to
 * the selected product, while this finder runs before a product is chosen.
 */
(async () => {
  const root = document.querySelector('[data-ab-vehicle-finder]');
  if (!root) return;

  const make = root.querySelector('[data-ab-make]');
  const model = root.querySelector('[data-ab-model]');
  const year = root.querySelector('[data-ab-year]');
  const submit = root.querySelector('[data-ab-submit]');
  const form = root.querySelector('form');
  const core = window.ABFitment;
  if (!make || !model || !year || !submit || !form || !core) return;

  let catalog = [];
  try {
    const response = await fetch(root.dataset.abFitmentCatalogUrl, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Catalog request failed');
    const payload = await response.json();
    catalog = Array.isArray(payload.products) ? payload.products : [];
  } catch (error) {
    console.error('Vehicle catalog loading error:', error);
    const status = root.querySelector('[data-ab-status]');
    if (status) status.textContent = 'Vehicle compatibility is temporarily unavailable. Please contact support.';
    return;
  }

  const hierarchy = core.build(catalog.map((product) => product.fitment).filter(Boolean)).hierarchy;

  const reset = (select, label) => {
    select.replaceChildren(new Option(label, ''));
    select.disabled = true;
  };

  Object.keys(hierarchy).sort().forEach((value) => make.add(new Option(value, value)));

  make.onchange = () => {
    reset(model, 'Select model');
    reset(year, 'Select year');
    submit.disabled = true;
    Object.keys(hierarchy[make.value] || {}).sort().forEach((value) => model.add(new Option(value, value)));
    model.disabled = !make.value;
  };

  model.onchange = () => {
    reset(year, 'Select year');
    submit.disabled = true;
    (hierarchy[make.value]?.[model.value] || []).forEach((value) => year.add(new Option(value, value)));
    year.disabled = !model.value;
  };

  year.onchange = () => {
    submit.disabled = !year.value;
  };

  form.onsubmit = (event) => {
    event.preventDefault();
    if (!make.value || !model.value || !year.value) return;
    const params = new URLSearchParams({ make: make.value, model: model.value, year: year.value });
    window.location.href = form.action + '?' + params;
  };
})();
